export default __webpack_public_path__ + "static/media/linkedin.232a6ef4.svg";